// ドロップダウン/メガメニュー: ゆっくりfade表示（既存アニメーションを削除してシンプルなフェードのみ）
(function initDropdownFadeAnimation() {
  var SHOW_MS = 500; /* 表示時: ゆっくりfade in */
  var HIDE_MS = 280; /* 非表示時: すこし早くfade out */

  function getDirectItems(contentElement) {
    return contentElement.querySelectorAll(":scope > li");
  }

  function getMegaMenuSections(contentElement) {
    var sections = [];
    var linklist = contentElement.querySelector(".mega-menu__linklist");
    if (linklist) sections.push(linklist);
    var promo = contentElement.querySelector(".mega-menu__promo");
    if (promo) sections.push(promo);
    return sections.length > 0 ? sections : Array.from(contentElement.children);
  }

  function cleanup(element) {
    element.style.removeProperty("opacity");
    element.style.removeProperty("pointer-events");
  }

  function createShowAnimation(contentElement) {
    if (!contentElement) return null;

    contentElement.style.opacity = "0";
    contentElement.style.pointerEvents = "none";
    var anim = contentElement.animate([{ opacity: 0 }, { opacity: 1 }], { duration: SHOW_MS, fill: "forwards", easing: "ease-out" });

    return {
      finished: anim.finished.then(function () {
        cleanup(contentElement);
        return true;
      }),
      finish: function () {
        anim.cancel();
        cleanup(contentElement);
      },
    };
  }

  function createHideAnimation(contentElement) {
    if (!contentElement) return null;

    contentElement.style.pointerEvents = "none";
    var anim = contentElement.animate([{ opacity: 1 }, { opacity: 0 }], { duration: HIDE_MS, fill: "forwards", easing: "ease-in" });

    return {
      finished: anim.finished.then(function () {
        cleanup(contentElement);
        return true;
      }),
      finish: function () {
        anim.cancel();
        cleanup(contentElement);
      },
    };
  }

  function applyOverride() {
    var DropdownCtor = customElements.get("dropdown-menu-disclosure");
    if (DropdownCtor) {
      DropdownCtor.prototype.createShowAnimationControls = function () {
        var ce = this.contentElement;
        return createShowAnimation(ce) || { finished: Promise.resolve(), finish: function () {} };
      };
      DropdownCtor.prototype.createHideAnimationControls = function () {
        return createHideAnimation(this.contentElement) || { finished: Promise.resolve(), finish: function () {} };
      };
    }

    var MegaCtor = customElements.get("mega-menu-disclosure");
    if (MegaCtor) {
      MegaCtor.prototype.createShowAnimationControls = function () {
        var ce = this.contentElement;
        return createShowAnimation(ce) || { finished: Promise.resolve(), finish: function () {} };
      };
      MegaCtor.prototype.createHideAnimationControls = function () {
        return createHideAnimation(this.contentElement) || { finished: Promise.resolve(), finish: function () {} };
      };
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyOverride);
  } else {
    applyOverride();
  }
})();

/* ヘッダーサイドバー: メニュー表示アニメーションを無効化（即座に表示） */
(function initHeaderSidebarNoAnimation() {
  function applyOverride() {
    var HeaderSidebarCtor = customElements.get("header-sidebar");
    if (HeaderSidebarCtor) {
      HeaderSidebarCtor.prototype.revealItems = function () {
        var panel = this.querySelector(".header-sidebar__main-panel");
        var items = this.querySelectorAll(".header-sidebar__main-panel .header-sidebar__linklist li");
        var footer = this.querySelector(".header-sidebar__footer");
        if (panel) {
          panel.style.opacity = "1";
          panel.style.transform = "";
        }
        Array.prototype.forEach.call(items, function (el) {
          el.style.removeProperty("opacity");
        });
        if (footer) {
          footer.style.removeProperty("opacity");
        }
        return { finished: Promise.resolve() };
      };
    }
  }
  applyOverride();
  customElements.whenDefined("header-sidebar").then(applyOverride);
})();

// Featured Collections: タブ切り替え時にボタンリンクを更新
document.addEventListener("DOMContentLoaded", function () {
  // #region agent log - サイズ選択のDOM確認
  setTimeout(function () {
    const variantPickers = document.querySelectorAll("variant-picker");
    variantPickers.forEach(function (picker, index) {
      const options = picker.querySelectorAll(".variant-picker__option");
      options.forEach(function (option, optIndex) {
        const legend = option.querySelector("legend");
        const optionName = legend ? legend.textContent.trim().replace(":", "") : "unknown";
        const optionValues = option.querySelectorAll(".variant-picker__option-values > *");
        const firstValue = optionValues[0];
        let valueType = "unknown";
        let hasText = false;
        let textContent = "";

        if (firstValue) {
          if (firstValue.classList.contains("color-swatch")) {
            valueType = "swatch";
            const srOnly = firstValue.querySelector(".sr-only");
            textContent = srOnly ? srOnly.textContent : "";
            hasText = !!srOnly;
          } else if (firstValue.classList.contains("block-swatch")) {
            valueType = "block";
            const span = firstValue.querySelector("span");
            textContent = span ? span.textContent : "";
            hasText = !!span && span.textContent.trim() !== "";
          } else {
            valueType = "other";
            textContent = firstValue.textContent || "";
            hasText = textContent.trim() !== "";
          }
        }

        const logData = {
          location: "custom.js:DOMContentLoaded",
          message: "サイズ選択オプション確認",
          data: {
            pickerIndex: index,
            optionIndex: optIndex,
            optionName: optionName,
            valueType: valueType,
            hasText: hasText,
            textContent: textContent,
            isSizeOption: optionName === "SIZE" || optionName.includes("サイズ"),
            classList: Array.from(firstValue ? firstValue.classList : []),
            optionClass: option.querySelector(".variant-picker__option-values") ? Array.from(option.querySelector(".variant-picker__option-values").classList) : [],
          },
          timestamp: Date.now(),
          sessionId: "debug-session",
          runId: "run1",
          hypothesisId: "A",
        };
        fetch("http://127.0.0.1:7243/ingest/36613118-3d44-421e-8033-6f8ba00187e7", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(logData),
        }).catch(() => {});
      });
    });
  }, 1000);
  // #endregion
  const featuredCollectionsCarousels = document.querySelectorAll("featured-collections-carousel");

  featuredCollectionsCarousels.forEach(function (carousel) {
    const sectionId = carousel.id.replace("featured-collections-carousel-", "");
    const linkButtonContainer = document.querySelector(`.featured-collections-link-button[data-section-id="${sectionId}"]`);

    if (!linkButtonContainer) return;

    const linkItems = linkButtonContainer.querySelectorAll(".featured-collections-link-button__item");
    const carouselItems = carousel.querySelectorAll(".featured-collections-carousel__item");

    // 選択状態を更新する関数
    function updateVisibleButton() {
      carouselItems.forEach(function (item, index) {
        if (item.classList.contains("is-selected")) {
          linkItems.forEach(function (linkItem, linkIndex) {
            if (linkIndex === index) {
              linkItem.classList.add("is-visible");
            } else {
              linkItem.classList.remove("is-visible");
            }
          });
        }
      });
    }

    // タブ切り替えイベントを監視
    carousel.addEventListener("carousel:change", function (event) {
      setTimeout(updateVisibleButton, 100);
    });

    // is-selectedクラスの変更を監視（MutationObserver）
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
          updateVisibleButton();
        }
      });
    });

    carouselItems.forEach(function (item) {
      observer.observe(item, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });

    // 初期状態を設定
    updateVisibleButton();
  });
});

// 374px未満のデバイスのレスポンシブ対応
!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');

  function switchViewport() {
    const value = window.outerWidth > 374 ? "width=device-width,initial-scale=1" : "width=374";

    if (viewport.getAttribute("content") !== value) {
      viewport.setAttribute("content", value);
    }
  }

  addEventListener("resize", switchViewport, false);
  switchViewport();
})();

// フィルタードロワー: CLEARボタンのクリックイベント
document.addEventListener("DOMContentLoaded", function () {
  function initDrawerClearButtons() {
    const drawerClearButtons = document.querySelectorAll(".c-facets-drawer__clear-button");

    drawerClearButtons.forEach(function (clearButton) {
      // 既にイベントリスナーが設定されている場合はスキップ
      if (clearButton.dataset.listenerAttached === "true") {
        return;
      }

      clearButton.dataset.listenerAttached = "true";
      clearButton.addEventListener("click", function () {
        // フィルター選択状態をリセット
        resetDrawerFilters();

        // 非同期でフィルターをクリア
        clearDrawerFilters();
      });
    });
  }

  function resetDrawerFilters() {
    // フィルターフォーム内のすべてのチェックボックスを解除
    const drawer = document.querySelector("facets-drawer");
    if (drawer) {
      drawer.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
        checkbox.checked = false;
      });

      // フィルターフォーム内のすべてのラジオボタンを解除
      drawer.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.checked = false;
      });

      // 価格範囲をリセット
      drawer.querySelectorAll('input[type="range"]').forEach(function (range) {
        const min = parseFloat(range.min);
        const max = parseFloat(range.max);
        if (range.getAttribute("aria-label") === "から") {
          range.value = min;
        } else if (range.getAttribute("aria-label") === "まで") {
          range.value = max;
        }
      });

      // 価格入力フィールドをリセット
      drawer.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]').forEach(function (input) {
        input.value = "";
      });
    }
  }

  function clearDrawerFilters() {
    // 現在のページタイプを判定
    const isSearchPage = document.querySelector(".main-search__resource-item") !== null;
    const isCollectionPage = document.querySelector(".collection__main") !== null;

    if (isSearchPage) {
      // 検索ページの場合
      const urlParams = new URLSearchParams(window.location.search);
      const searchQuery = urlParams.get("q");

      if (searchQuery) {
        const cleanUrl = window.location.origin + window.location.pathname + "?q=" + encodeURIComponent(searchQuery) + "&type=product";
        fetchSearchProducts(cleanUrl).then(function (html) {
          if (html) {
            updateSearchList(html);
            // drawerを閉じる
            const drawer = document.querySelector("facets-drawer");
            if (drawer) {
              drawer.removeAttribute("open");
            }
          }
        });
      } else {
        const cleanUrl = window.location.origin + window.location.pathname;
        fetchSearchProducts(cleanUrl).then(function (html) {
          if (html) {
            updateSearchList(html);
            const drawer = document.querySelector("facets-drawer");
            if (drawer) {
              drawer.removeAttribute("open");
            }
          }
        });
      }
    } else if (isCollectionPage) {
      // コレクションページの場合
      const collectionUrl = window.location.origin + window.location.pathname;
      fetchCollectionProducts(collectionUrl).then(function (html) {
        if (html) {
          updateCollectionList(html);
          // drawerを閉じる
          const drawer = document.querySelector("facets-drawer");
          if (drawer) {
            drawer.removeAttribute("open");
          }
        }
      });
    }
  }

  function fetchSearchProducts(url) {
    // 検索ページのセクションIDを取得
    const sectionId = document.querySelector(".shopify-section--main-search")?.id?.replace("shopify-section-", "");
    if (!sectionId) {
      // セクションIDが取得できない場合は、ページをリロード
      window.location.href = url;
      return Promise.resolve("");
    }

    // APIエンドポイントにリクエストを送る
    const fetchUrl = url + (url.includes("?") ? "&" : "?") + "section_id=" + sectionId;

    // ローディング開始
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    return fetch(fetchUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then(function (html) {
        // ローディング終了
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        return html;
      })
      .catch(function (error) {
        console.error("Error fetching search products:", error);
        // ローディング終了
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        // エラーが発生した場合は、ページをリロード
        window.location.href = url;
        return "";
      });
  }

  function updateSearchList(html) {
    if (!html) {
      return;
    }

    // HTMLをパース
    const parser = new DOMParser();
    const tempDoc = parser.parseFromString(html, "text/html");
    const newSection = tempDoc.querySelector(".shopify-section--main-search");

    if (!newSection) {
      return;
    }

    // 現在のセクションを新しいセクションで置き換え
    const currentSection = document.querySelector(".shopify-section--main-search");
    if (currentSection) {
      // URLを更新
      const url = new URL(window.location.href);
      url.searchParams.delete("filter");
      url.searchParams.delete("sort_by");
      history.replaceState({}, "", url.toString());

      // セクションを置き換え
      currentSection.replaceWith(newSection);

      // イベントリスナーを再設定
      initDrawerClearButtons();
    }
  }

  function fetchCollectionProducts(url) {
    // コレクションページのセクションIDを取得
    const sectionId = document.querySelector(".shopify-section--main-collection")?.id?.replace("shopify-section-", "");
    if (!sectionId) {
      // セクションIDが取得できない場合は、ページをリロード
      window.location.href = url;
      return Promise.resolve("");
    }

    // APIエンドポイントにリクエストを送る
    const fetchUrl = url + (url.includes("?") ? "&" : "?") + "section_id=" + sectionId;

    // ローディング開始
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    return fetch(fetchUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then(function (html) {
        // ローディング終了
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        return html;
      })
      .catch(function (error) {
        console.error("Error fetching collection products:", error);
        // ローディング終了
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
        // エラーが発生した場合は、ページをリロード
        window.location.href = url;
        return "";
      });
  }

  function updateCollectionList(html) {
    if (!html) {
      return;
    }

    // HTMLをパース
    const parser = new DOMParser();
    const tempDoc = parser.parseFromString(html, "text/html");
    const newSection = tempDoc.querySelector(".shopify-section--main-collection");

    if (!newSection) {
      return;
    }

    // 現在のセクションを新しいセクションで置き換え
    const currentSection = document.querySelector(".shopify-section--main-collection");
    if (currentSection) {
      // URLを更新
      const url = new URL(window.location.href);
      url.searchParams.delete("filter");
      url.searchParams.delete("sort_by");
      history.replaceState({}, "", url.toString());

      // セクションを置き換え
      currentSection.replaceWith(newSection);

      // イベントリスナーを再設定
      initDrawerClearButtons();

      // コレクションのリストがAJAXで更新されたことを通知（ページネーション/絞り込み等）
      // - 他のカスタム処理（Outfit/Product切替の再適用など）の再初期化トリガーとして使う
      document.dispatchEvent(new CustomEvent("shopify:collection:updated"));
    }
  }

  // drawer用のCLEARボタンを初期化
  initDrawerClearButtons();

  // drawerが開かれたときにイベントリスナーを再設定（動的に追加される要素に対応）
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        initDrawerClearButtons();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

/**
 * Collection: Mobile thumbnail bulk switcher (Outfit/Product)
 * - Outfit: set each product card image to initial 1st media (restore)
 * - Product: set each product card image to initial 3rd media (if exists)
 * - Product + カラー系フィルターON（data-c-active-color-facet）: Outfit と同じく primary（featured_media）を表示
 * - After switching: clear all color swatch selections (radio checked) and restore links
 *
 * NOTE:
 * - We MUST NOT remove/replace `.product-card__image--primary` itself because theme's `ProductCard` JS relies on it.
 * - We store initial primary/secondary/tertiary img attributes on the `product-card` element (dataset) so it survives swatch-driven DOM replacements.
 */
(function () {
  const BUTTON_SELECTOR = ".c-main-collection__thumbnail-change-button";

  const ATTRS_TO_COPY = ["src", "srcset", "sizes", "alt", "width", "height", "loading", "fetchpriority", "decoding"];

  const STORAGE_KEY_PREFIX = "cCollectionThumbMode:";
  const OBSERVER_MARK = "cCollectionThumbObserverAttached";
  let reinitTimer = null;
  let bulkSwitchTimer = null;
  let bulkFadeInTimer = null;

  function scheduleInitialize(delayMs) {
    window.clearTimeout(reinitTimer);
    reinitTimer = window.setTimeout(() => {
      initializeThumbnailMode();
      // If section was replaced by custom scripts (replaceWith), ensure we keep observing the new one too
      attachSectionObserver();
    }, delayMs || 0);
  }

  function getStorageKey() {
    // Collection per-path (e.g. /collections/xxx) so modes don't bleed across collections
    return STORAGE_KEY_PREFIX + (window.location?.pathname || "");
  }

  function readStoredMode() {
    try {
      const raw = window.sessionStorage?.getItem(getStorageKey());
      if (raw === "product" || raw === "outfit") return raw;
      return null;
    } catch (e) {
      return null;
    }
  }

  function writeStoredMode(mode) {
    try {
      if (mode !== "product" && mode !== "outfit") return;
      window.sessionStorage?.setItem(getStorageKey(), mode);
    } catch (e) {
      // ignore (private mode / quota etc.)
    }
  }

  function getMainCollectionRoot() {
    return document.querySelector(".shopify-section--main-collection");
  }

  function isActiveColorOptionFacet(root) {
    const el = root?.querySelector?.(".c-main-collection__thumbnail-change");
    return el?.dataset?.cActiveColorFacet === "true";
  }

  function isNarrowViewport() {
    return (window.innerWidth || document.documentElement.clientWidth) <= 999;
  }

  function snapshotImg(img) {
    if (!img) return null;
    const snap = {};

    ATTRS_TO_COPY.forEach((attr) => {
      const value = img.getAttribute(attr);
      if (value !== null) snap[attr] = value;
    });

    return snap;
  }

  function applyImgSnapshot(img, snap) {
    if (!img || !snap) return;

    // Keep the same element; update attributes only (DO NOT touch class names).
    ATTRS_TO_COPY.forEach((attr) => {
      if (snap[attr] === undefined) {
        img.removeAttribute(attr);
      } else {
        img.setAttribute(attr, snap[attr]);
      }
    });
  }

  function ensureCardSnapshots(card) {
    if (!card || card.dataset.cCollectionThumbSnapshots === "true") return;

    const primary = card.querySelector(".product-card__image--primary");
    const secondary = card.querySelector(".product-card__image--secondary");
    const tertiary = card.querySelector(".product-card__image--tertiary");

    const primarySnap = snapshotImg(primary);
    const secondarySnap = snapshotImg(secondary); // may be null (no 2nd image)
    const tertiarySnap = snapshotImg(tertiary); // may be null (no 3rd image)

    if (primarySnap) {
      card.dataset.cPrimaryImgSnap = JSON.stringify(primarySnap);
    }
    if (secondarySnap) {
      card.dataset.cSecondaryImgSnap = JSON.stringify(secondarySnap);
    }
    if (tertiarySnap) {
      card.dataset.cTertiaryImgSnap = JSON.stringify(tertiarySnap);
    }

    // Save original product links so we can restore after swatch selection changed URLs
    card.querySelectorAll(`a[href^="${Shopify?.routes?.root || "/"}products/"]`).forEach((a) => {
      if (!a.dataset.cOriginalHref) a.dataset.cOriginalHref = a.getAttribute("href") || "";
    });

    card.dataset.cCollectionThumbSnapshots = "true";
  }

  function restoreCardLinks(card) {
    if (!card) return;
    card.querySelectorAll("a[data-c-original-href]").forEach((a) => {
      const original = a.dataset.cOriginalHref;
      if (original) a.setAttribute("href", original);
    });
  }

  function clearCardSwatches(card) {
    if (!card) return;

    // Clear checked radios inside product-card info (swatches)
    card.querySelectorAll('.product-card__info input[type="radio"]').forEach((input) => {
      if (input.checked) input.checked = false;
    });
  }

  function getSnapshotFromDataset(card, key) {
    try {
      const raw = card.dataset[key];
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  const BULK_SWITCH_FADE_MS = 500; /* custom.css の transition 0.5s に合わせる */

  function clearBulkSwitchTimers() {
    if (bulkSwitchTimer) {
      window.clearTimeout(bulkSwitchTimer);
      bulkSwitchTimer = null;
    }

    if (bulkFadeInTimer) {
      window.clearTimeout(bulkFadeInTimer);
      bulkFadeInTimer = null;
    }
  }

  function stopPendingBulkSwitch() {
    clearBulkSwitchTimers();

    const root = getMainCollectionRoot();
    if (!root) return;

    root.querySelectorAll("product-card.product-card, product-card").forEach((card) => {
      card.classList.remove("c-product-card__bulk-switching");
    });
  }

  function switchAllCards(mode) {
    const root = getMainCollectionRoot();
    if (!root) return;

    // This control is displayed only up to 999px; keep it no-op above that to avoid unexpected behavior.
    if (!isNarrowViewport()) return;

    const cards = Array.from(root.querySelectorAll("product-card.product-card, product-card"));

    clearBulkSwitchTimers();

    // モード切替時点で既存のスウォッチ選択状態だけをリセットし、
    // 遅延後の一括処理がユーザーの直後操作を上書きしないようにする。
    cards.forEach((card) => {
      ensureCardSnapshots(card);
      clearCardSwatches(card);
      restoreCardLinks(card);
    });

    // フェードアウト開始
    cards.forEach((card) => card.classList.add("c-product-card__bulk-switching"));

    // フェードアウト完了後に画像を差し替え、フェードイン
    bulkSwitchTimer = window.setTimeout(() => {
      bulkSwitchTimer = null;
      cards.forEach((card) => {
        if (!card.isConnected) return;

        const primary = card.querySelector(".product-card__image--primary");
        if (!primary) return;

        // Ensure we never accidentally convert the primary image into a "secondary" one (CSS hides secondary by default).
        primary.classList.add("product-card__image", "product-card__image--primary");
        primary.classList.remove("product-card__image--secondary");

        const primarySnap = getSnapshotFromDataset(card, "cPrimaryImgSnap");
        const secondarySnap = getSnapshotFromDataset(card, "cSecondaryImgSnap");
        const tertiarySnap = getSnapshotFromDataset(card, "cTertiaryImgSnap");

        const productUsesPrimaryLikeOutfit = mode === "product" && isActiveColorOptionFacet(root);

        if (mode === "outfit" || productUsesPrimaryLikeOutfit) {
          if (primarySnap) applyImgSnapshot(primary, primarySnap);
        } else if (mode === "product") {
          // If no 3rd image snapshot exists, skip (requirement)
          if (tertiarySnap) applyImgSnapshot(primary, tertiarySnap);
        }
      });

      // 画像差し替え後、フェードイン開始
      bulkFadeInTimer = window.setTimeout(() => {
        bulkFadeInTimer = null;
        cards.forEach((card) => card.classList.remove("c-product-card__bulk-switching"));
      }, 50);
    }, BULK_SWITCH_FADE_MS);
  }

  function isProductCardSwatchInput(target) {
    return (
      target instanceof HTMLInputElement &&
      target.type === "radio" &&
      target.hasAttribute("data-variant-media") &&
      !!target.closest(".product-card__info")
    );
  }

  function isProductCardSwatchInteractionTarget(target) {
    if (!(target instanceof Element)) return false;

    if (isProductCardSwatchInput(target)) return true;

    const label = target.closest(".product-card__info label[for]");
    if (!label) return false;

    const control = label.control || document.getElementById(label.htmlFor);
    return isProductCardSwatchInput(control);
  }

  function setActiveButton(clickedButton) {
    const container = clickedButton?.closest(".c-main-collection__thumbnail-change");
    if (!container) return;

    container.querySelectorAll(BUTTON_SELECTOR).forEach((btn) => {
      btn.classList.toggle("is-active", btn === clickedButton);
    });
  }

  function setActiveButtonByMode(root, mode) {
    const container = root?.querySelector?.(".c-main-collection__thumbnail-change");
    if (!container) return;

    const buttons = Array.from(container.querySelectorAll(BUTTON_SELECTOR));
    if (buttons.length === 0) return;

    buttons.forEach((btn) => {
      const label = (btn.textContent || "").trim().toLowerCase();
      const btnMode = label === "product" ? "product" : "outfit";
      btn.classList.toggle("is-active", btnMode === mode);
    });
  }

  function applyMode(mode) {
    const root = getMainCollectionRoot();
    if (!root) return;

    // Keep UI + list in sync
    setActiveButtonByMode(root, mode);
    switchAllCards(mode);
  }

  function attachSectionObserver() {
    const section = getMainCollectionRoot();
    if (!section) return;
    if (section.dataset[OBSERVER_MARK] === "true") return;

    const observer = new MutationObserver((mutations) => {
      // When facets/pagination updates via theme.js, it does `section.replaceChildren(...)`
      // We re-apply mode only AFTER the DOM is actually replaced.
      for (const m of mutations) {
        if (m.type === "childList" && (m.addedNodes?.length || m.removedNodes?.length)) {
          scheduleInitialize(0);
          break;
        }
      }
    });

    // IMPORTANT:
    // `product-card` swatch change replaces media <img> nodes inside the section.
    // If we observe with `subtree: true`, those internal mutations trigger re-initialize,
    // which clears swatch selection + restores thumbnails immediately (looks like "swatch doesn't work").
    // We only need to observe direct child changes on the section itself (facets/pagination uses replaceChildren on section).
    observer.observe(section, { childList: true, subtree: false });
    section.dataset[OBSERVER_MARK] = "true";
  }

  // Event delegation (works after AJAX section replacement)
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(BUTTON_SELECTOR);
    if (!btn) return;

    const root = getMainCollectionRoot();
    if (!root || !root.contains(btn)) return;

    const label = (btn.textContent || "").trim().toLowerCase();
    const mode = label === "product" ? "product" : "outfit";

    // Persist user's choice across pagination / faceting AJAX updates (mobile only UI)
    writeStoredMode(mode);

    setActiveButton(btn);
    switchAllCards(mode);
  });

  // Product/Outfit切替の保留中に商品カードの色スウォッチを触った場合は、
  // そのユーザー操作を優先して一括切替の後追い反映を止める。
  document.addEventListener(
    "pointerdown",
    function (e) {
      if (!isProductCardSwatchInteractionTarget(e.target)) return;
      stopPendingBulkSwitch();
    },
    true,
  );

  document.addEventListener(
    "change",
    function (e) {
      if (!isProductCardSwatchInput(e.target)) return;
      stopPendingBulkSwitch();
    },
    true,
  );

  // Initialize based on metafield value
  function initializeThumbnailMode() {
    const root = getMainCollectionRoot();
    if (!root) return;

    const thumbnailChangeContainer = root.querySelector(".c-main-collection__thumbnail-change");
    if (!thumbnailChangeContainer) return;

    // Priority:
    // 1) stored mode (user choice)
    // 2) dataset initial mode (metafield-driven)
    const storedMode = readStoredMode();
    const initialMode = thumbnailChangeContainer.dataset.initialMode;
    const mode = storedMode || (initialMode === "product" ? "product" : "outfit");

    // Ensure buttons are always synced (AJAX replace may reset classes)
    // NOTE: For default "outfit" (no stored mode, no metafield forcing product),
    // keep legacy behavior (do not touch cards) to avoid unnecessary resets.
    setActiveButtonByMode(root, mode);
    if (mode === "outfit" && !storedMode && initialMode !== "product") {
      return;
    }

    // Apply mode to cards (no-op above 999px)
    applyMode(mode);
  }

  // Initialize on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      attachSectionObserver();
      initializeThumbnailMode();
    });
  } else {
    attachSectionObserver();
    initializeThumbnailMode();
  }

  // Also initialize after AJAX section replacement (Shopify theme editor)
  document.addEventListener("shopify:section:load", function (e) {
    if (e.detail.sectionId && e.detail.sectionId.includes("main-collection")) {
      setTimeout(function () {
        attachSectionObserver();
        initializeThumbnailMode();
      }, 100);
    }
  });

  // Re-initialize after faceting/pagination AJAX updates
  document.addEventListener("facet:update", function () {
    // `facet:update` is fired BEFORE the async fetch + DOM replacement completes.
    // We attach an observer and also do a delayed best-effort initialize as fallback.
    attachSectionObserver();
    scheduleInitialize(700);
  });

  // Re-initialize after collection section replacement done by custom scripts or theme
  document.addEventListener("shopify:collection:updated", function () {
    setTimeout(function () {
      attachSectionObserver();
      initializeThumbnailMode();
    }, 100);
  });
})();

// Sort Button: ソート変更時にボタンのテキストを更新
document.addEventListener("DOMContentLoaded", function () {
  // ソートラベルのマッピング
  const sortLabelMap = {
    manual: "オススメ",
    "best-selling": "ベストセラー",
    "title-ascending": "アルファベット順, A-Z",
    "title-descending": "アルファベット順, Z-A",
    "price-ascending": "価格の安い順",
    "price-descending": "価格の高い順",
    "created-ascending": "古い商品順",
    "created-descending": "新着順",
  };

  // ソートボタンのラベルを確保する関数
  function ensureSortButtonLabel(sortButton) {
    if (!sortButton) return;

    let sortButtonLabel = sortButton.querySelector(".c-main-collection__sort-button-label");

    // ラベルが存在しない場合は作成
    if (!sortButtonLabel) {
      sortButtonLabel = document.createElement("span");
      sortButtonLabel.className = "c-main-collection__sort-button-label";
      sortButtonLabel.textContent = "並び替え：";

      // テキスト要素の前に挿入
      const sortButtonText = sortButton.querySelector(".c-main-collection__sort-button-text");
      if (sortButtonText) {
        sortButton.insertBefore(sortButtonLabel, sortButtonText);
      } else {
        // テキスト要素も存在しない場合は、最初に挿入
        sortButton.insertBefore(sortButtonLabel, sortButton.firstChild);
      }
    }
  }

  // ソートボタンのテキストを更新する関数
  function updateSortButtonText(sortValue) {
    const sortButton = document.querySelector(".c-main-collection__sort-button");
    if (!sortButton) return;

    // ラベルが存在することを確認
    ensureSortButtonLabel(sortButton);

    const sortButtonText = sortButton.querySelector(".c-main-collection__sort-button-text");
    if (!sortButtonText) return;

    const label = sortLabelMap[sortValue] || "並び替え";
    sortButtonText.textContent = label;
    sortButton.setAttribute("data-selected-value", sortValue);
  }

  // ソート変更イベントを監視
  document.addEventListener("listbox:change", function (event) {
    const sortPopover = event.target.closest("facets-sort-popover");
    if (!sortPopover) return;

    const sortValue = event.detail.value;
    updateSortButtonText(sortValue);
  });

  // ページ更新後にボタンのテキストを更新（AJAX更新時に対応）
  function initSortButton() {
    const sortButton = document.querySelector(".c-main-collection__sort-button");
    if (!sortButton) return;

    // ラベルが存在することを確認
    ensureSortButtonLabel(sortButton);

    const selectedValue = sortButton.getAttribute("data-selected-value");
    if (selectedValue) {
      updateSortButtonText(selectedValue);
    }
  }

  // 初期化
  initSortButton();

  // facet:updateイベント後に再初期化（AJAX更新時に対応）
  document.addEventListener("facet:update", function () {
    setTimeout(function () {
      initSortButton();
    }, 100);
  });

  // セクションが更新されたときに再初期化
  const sectionObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        // 新しいセクションが追加された場合、少し遅延してから初期化
        setTimeout(initSortButton, 100);
      }
    });
  });

  const collectionSection = document.querySelector(".shopify-section--main-collection");
  if (collectionSection) {
    sectionObserver.observe(collectionSection, {
      childList: true,
      subtree: true,
    });
  }
});

// Product Gallery: 最後まで到達したときに1枚目に戻る機能
document.addEventListener("DOMContentLoaded", function () {
  function initProductGalleryCarousel() {
    const productGalleries = document.querySelectorAll("product-gallery");

    productGalleries.forEach(function (gallery) {
      const carousel = gallery.querySelector("scroll-carousel");
      if (!carousel) return;

      const prevButton = gallery.querySelector("carousel-prev-button");
      const nextButton = gallery.querySelector("carousel-next-button");
      if (!prevButton || !nextButton) return;

      // 既に初期化済みの場合はスキップ
      if (prevButton.dataset.customInit === "true" || nextButton.dataset.customInit === "true") {
        return;
      }

      // カルーセルのセル数を取得（hiddenでないもののみ）
      function getVisibleCells() {
        return Array.from(carousel.cells || []).filter(function (cell) {
          return !cell.hasAttribute("hidden");
        });
      }

      // 現在のインデックスを取得
      function getCurrentIndex() {
        const visibleCells = getVisibleCells();
        if (visibleCells.length === 0) return 0;
        const currentIndex = carousel.selectedIndex || 0;
        const currentCell = carousel.cells[currentIndex];
        if (!currentCell) return 0;
        return visibleCells.indexOf(currentCell);
      }

      // 最後のセルかどうかを判定
      function isLastCell() {
        const visibleCells = getVisibleCells();
        if (visibleCells.length === 0) return false;
        const currentIndex = getCurrentIndex();
        return currentIndex >= visibleCells.length - 1;
      }

      // 最初のセルかどうかを判定
      function isFirstCell() {
        const visibleCells = getVisibleCells();
        if (visibleCells.length === 0) return false;
        const currentIndex = getCurrentIndex();
        return currentIndex <= 0;
      }

      // Nextボタンのクリックイベントをインターセプト
      const originalNextHandler = function () {
        const visibleCells = getVisibleCells();
        if (visibleCells.length === 0) return;

        if (isLastCell()) {
          // 最後のセルの場合は1枚目に戻る
          const firstCell = visibleCells[0];
          const firstIndex = Array.from(carousel.cells || []).indexOf(firstCell);
          if (firstIndex !== -1) {
            carousel.select(firstIndex, { instant: false });
          }
        } else {
          // 通常のnext動作
          carousel.next();
        }
      };

      // Prevボタンのクリックイベントをインターセプト
      const originalPrevHandler = function () {
        const visibleCells = getVisibleCells();
        if (visibleCells.length === 0) return;

        if (isFirstCell()) {
          // 最初のセルの場合は最後のセルに移動
          const lastCell = visibleCells[visibleCells.length - 1];
          const lastIndex = Array.from(carousel.cells || []).indexOf(lastCell);
          if (lastIndex !== -1) {
            carousel.select(lastIndex, { instant: false });
          }
        } else {
          // 通常のprevious動作
          carousel.previous();
        }
      };

      // 既存のイベントリスナーを削除して、新しいハンドラーを追加
      // carousel-prev-buttonとcarousel-next-buttonはclickイベントをリスニングしている
      // イベントをキャプチャフェーズでインターセプト
      nextButton.addEventListener(
        "click",
        function (e) {
          e.stopImmediatePropagation();
          originalNextHandler();
        },
        true,
      );

      prevButton.addEventListener(
        "click",
        function (e) {
          e.stopImmediatePropagation();
          originalPrevHandler();
        },
        true,
      );

      // 初期化済みフラグを設定
      prevButton.dataset.customInit = "true";
      nextButton.dataset.customInit = "true";
    });
  }

  // 初期化
  initProductGalleryCarousel();

  // セクションが更新されたときに再初期化（AJAX更新時に対応）
  document.addEventListener("shopify:section:load", function () {
    setTimeout(initProductGalleryCarousel, 100);
  });

  // セクションが更新されたときに再初期化
  const galleryObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        setTimeout(initProductGalleryCarousel, 100);
      }
    });
  });

  galleryObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// Product Gallery: carousel_thumbnails_bottom時のサムネイル枠線（表示中の2枚に対応）
document.addEventListener("DOMContentLoaded", function () {
  function updateThumbnailBorders() {
    const productGalleries = document.querySelectorAll("product-gallery");

    productGalleries.forEach(function (gallery) {
      const carousel = gallery.querySelector("scroll-carousel");
      const thumbnailScroller = gallery.querySelector("product-gallery-navigation");

      if (!carousel || !thumbnailScroller) return;

      // carousel_thumbnails_bottomの時のみ処理（デスクトップのみ）
      if (window.innerWidth < 1000) return;

      const carouselGrid = window.getComputedStyle(carousel).getPropertyValue("--product-gallery-carousel-grid");
      const isBottomLayout = carouselGrid && carouselGrid.includes("calc((100% - 10px) / 2)");
      if (!isBottomLayout) return;

      // すべてのサムネイルからis-visibleクラスを削除
      const thumbnails = thumbnailScroller.querySelectorAll(".product-gallery__thumbnail");
      thumbnails.forEach(function (thumb) {
        thumb.classList.remove("is-visible");
      });

      // 表示されているメディアを特定
      const visibleMedia = [];

      // carousel.cellsが利用可能な場合
      if (carousel.cells && carousel.cells.length > 0) {
        const cells = Array.from(carousel.cells);
        const selectedIndex = carousel.selectedIndex || 0;

        // 現在選択されているセル
        const selectedCell = cells[selectedIndex];
        if (selectedCell && !selectedCell.hasAttribute("hidden")) {
          const mediaId = selectedCell.getAttribute("data-media-id");
          if (mediaId) visibleMedia.push(mediaId);
        }

        // 次のセル（2枚表示の場合）
        const nextIndex = selectedIndex + 1;
        const nextCell = cells[nextIndex];
        if (nextCell && !nextCell.hasAttribute("hidden")) {
          const mediaId = nextCell.getAttribute("data-media-id");
          if (mediaId) visibleMedia.push(mediaId);
        }
      } else {
        // carousel.cellsが利用できない場合は、DOMから直接取得
        const mediaElements = carousel.querySelectorAll(".product-gallery__media:not([hidden])");
        const visibleElements = Array.from(mediaElements).slice(0, 2); // 最初の2枚

        visibleElements.forEach(function (mediaElement) {
          const mediaId = mediaElement.getAttribute("data-media-id");
          if (mediaId) visibleMedia.push(mediaId);
        });
      }

      // 対応するサムネイルにis-visibleクラスを追加
      visibleMedia.forEach(function (mediaId) {
        const thumbnail = thumbnailScroller.querySelector(`.product-gallery__thumbnail[data-media-id="${mediaId}"]`);
        if (thumbnail && !thumbnail.hasAttribute("hidden")) {
          thumbnail.classList.add("is-visible");
        }
      });
    });
  }

  function initThumbnailBorders() {
    updateThumbnailBorders();

    // 各ギャラリーのカルーセルにイベントリスナーを追加
    const productGalleries = document.querySelectorAll("product-gallery");
    productGalleries.forEach(function (gallery) {
      const carousel = gallery.querySelector("scroll-carousel");
      if (!carousel) return;

      // 既にリスナーが追加されている場合はスキップ
      if (carousel.dataset.thumbnailBorderListener === "true") return;
      carousel.dataset.thumbnailBorderListener = "true";

      // カルーセル変更時に更新
      carousel.addEventListener("carousel:settle", function () {
        setTimeout(updateThumbnailBorders, 50);
      });

      carousel.addEventListener("carousel:change", function () {
        setTimeout(updateThumbnailBorders, 50);
      });

      // スクロール時にも更新（2枚表示の場合）
      carousel.addEventListener("scroll", function () {
        setTimeout(updateThumbnailBorders, 100);
      });
    });
  }

  // 初期化
  initThumbnailBorders();

  // セクションが更新されたときに再初期化
  document.addEventListener("shopify:section:load", function () {
    setTimeout(initThumbnailBorders, 100);
  });

  // リサイズ時にも更新
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initThumbnailBorders();
    }, 250);
  });

  // 動的に追加された要素に対応
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        setTimeout(initThumbnailBorders, 100);
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// Custom Acordion: トグル機能
document.addEventListener("DOMContentLoaded", function () {
  function initAcordion() {
    const acordionToggles = document.querySelectorAll(".c-acordion__toggle");

    acordionToggles.forEach(function (toggle) {
      // 既にイベントリスナーが設定されている場合はスキップ
      if (toggle.dataset.listenerAttached === "true") {
        return;
      }

      toggle.dataset.listenerAttached = "true";

      toggle.addEventListener("click", function () {
        const content = toggle.nextElementSibling;

        if (content && content.classList.contains("c-acordion__content")) {
          const isOpen = content.classList.contains("is-open");

          if (isOpen) {
            content.classList.remove("is-open");
            toggle.classList.remove("is-active");
          } else {
            content.classList.add("is-open");
            toggle.classList.add("is-active");
          }
        }
      });
    });
  }

  // 初期化
  initAcordion();

  // 動的に追加された要素に対応
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        initAcordion();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// Footer Accordion: フッターアコーディオンのトグル機能
document.addEventListener("DOMContentLoaded", function () {
  function initFooterAccordion() {
    const footerAccordionToggles = document.querySelectorAll(".c-footer__accordion-toggle");

    footerAccordionToggles.forEach(function (toggle) {
      // 既にイベントリスナーが設定されている場合はスキップ
      if (toggle.dataset.listenerAttached === "true") {
        return;
      }

      toggle.dataset.listenerAttached = "true";

      toggle.addEventListener("click", function () {
        const content = toggle.nextElementSibling;

        if (content && content.classList.contains("c-footer__accordion-content")) {
          const isOpen = content.classList.contains("is-open");
          const isExpanded = toggle.getAttribute("aria-expanded") === "true";

          if (isOpen || isExpanded) {
            content.classList.remove("is-open");
            toggle.setAttribute("aria-expanded", "false");
          } else {
            content.classList.add("is-open");
            toggle.setAttribute("aria-expanded", "true");
          }
        }
      });
    });
  }

  // 初期化
  initFooterAccordion();

  // 動的に追加された要素に対応
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        initFooterAccordion();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// アコーディオンテーブルのレスポンシブ幅設定
!(function () {
  function setTableWrapper() {
    const sizeTables = document.querySelectorAll(".c-acordion__table--size");

    // より正確な画面幅を取得
    const screenWidth = document.documentElement.clientWidth;

    sizeTables.forEach((table) => {
      // .c-acordion__table--sizeを含む.table-wrapperを探す
      const tableWrapper = table.closest(".table-wrapper");

      if (tableWrapper) {
        if (screenWidth <= 740) {
          // CSS変数からガター値を取得
          const containerGutter = getComputedStyle(document.documentElement).getPropertyValue("--container-gutter");
          const gutterValue = parseFloat(containerGutter) || 0;

          // 画面幅からガター*2を引いた値を計算
          const calculatedWidth = screenWidth - gutterValue * 2;

          // .table-wrapperに横スクロールと幅を設定
          tableWrapper.style.overflowX = "scroll"; // 常時スクロールバー表示
          tableWrapper.style.overflowY = "hidden";
          tableWrapper.style.width = calculatedWidth + "px";
          tableWrapper.style.maxWidth = calculatedWidth + "px";
          tableWrapper.style.setProperty("-webkit-overflow-scrolling", "touch");
          // スクロールバー用の溝を常に確保（対応ブラウザ向け）
          tableWrapper.style.setProperty("scrollbar-gutter", "stable both-edges");
          // SimpleBar属性を付与
          tableWrapper.setAttribute("data-simplebar", "");
          tableWrapper.setAttribute("data-simplebar-auto-hide", "false");

          // テーブル自体にも最小幅を設定
          table.style.minWidth = "600px";
          table.style.width = "600px";
        } else {
          // 740pxより大きい場合はスタイルを削除
          tableWrapper.style.overflowX = "";
          tableWrapper.style.width = "";
          tableWrapper.style.maxWidth = "";
          table.style.minWidth = "";
          table.style.width = "";
        }
      }
    });
  }

  // 初回実行
  setTableWrapper();

  // リサイズイベントで実行
  window.addEventListener("resize", setTableWrapper);

  // DOMContentLoadedイベントでも実行（動的に追加されたテーブルに対応）
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setTableWrapper);
  }
})();

// サイズチャートテーブルにインラインスタイルでボーダーを追加
!(function () {
  function getTextColor() {
    // CSS変数からテキストカラーを取得
    const textColor = getComputedStyle(document.documentElement).getPropertyValue("--text-color").trim();
    if (textColor) {
      // RGB値が取得できた場合
      const rgbValues = textColor.split(",").map((v) => v.trim());
      if (rgbValues.length === 3) {
        return `rgba(${rgbValues[0]}, ${rgbValues[1]}, ${rgbValues[2]}, 0.2)`;
      }
    }
    // フォールバック
    return "rgba(25, 22, 22, 0.2)";
  }

  function getTextColorLight() {
    const textColor = getComputedStyle(document.documentElement).getPropertyValue("--text-color").trim();
    if (textColor) {
      const rgbValues = textColor.split(",").map((v) => v.trim());
      if (rgbValues.length === 3) {
        return `rgba(${rgbValues[0]}, ${rgbValues[1]}, ${rgbValues[2]}, 0.1)`;
      }
    }
    return "rgba(25, 22, 22, 0.1)";
  }

  function applySizeChartStyles() {
    const sizeChartContainers = document.querySelectorAll(".c-acordion__table--size");
    const borderColor = getTextColor();
    const bgColor = getTextColorLight();

    sizeChartContainers.forEach((container) => {
      // Simplebarを適用するためのラッパーを作成または取得
      let wrapper = container;

      // 既にラッパーがある場合はそれを使用、ない場合は作成
      if (!container.classList.contains("table-wrapper")) {
        // コンテナにSimplebar用のスタイルを適用
        container.style.overflowX = "auto";
        container.style.overflowY = "hidden";
        container.style.width = "100%";
        container.style.maxWidth = "100%";

        // Simplebar属性を付与
        if (!container.hasAttribute("data-simplebar")) {
          container.setAttribute("data-simplebar", "");
          container.setAttribute("data-simplebar-auto-hide", "false");
        }
      }

      const tables = container.querySelectorAll("table");

      tables.forEach((table) => {
        // テーブル全体に左と上のボーダーを設定
        table.style.borderLeft = `1px solid ${borderColor}`;
        table.style.borderTop = `1px solid ${borderColor}`;
        table.style.borderRight = "none";
        table.style.borderBottom = "none";
        table.style.borderCollapse = "separate";
        table.style.borderSpacing = "0";
        // 画面幅に応じてfont-sizeを調整（999px以下の場合は10px）
        const screenWidth = window.innerWidth || document.documentElement.clientWidth;
        const fontSize = screenWidth <= 999 ? "10px" : "11px";
        table.style.fontSize = fontSize;
        table.style.fontFamily = "var(--text-font-family)";
        table.style.fontWeight = "500";

        // すべてのthとtdに右と下のボーダーを設定（線が重ならないように）
        const cells = table.querySelectorAll("th, td");
        cells.forEach((cell) => {
          cell.style.borderRight = `1px solid ${borderColor}`;
          cell.style.borderBottom = `1px solid ${borderColor}`;
          cell.style.borderLeft = "none";
          cell.style.borderTop = "none";
          cell.style.padding = "4px 8px";
          cell.style.fontSize = fontSize;
          cell.style.textAlign = "center";
          cell.style.minWidth = "50px";
          cell.style.fontFamily = "var(--text-font-family)";
          cell.style.fontWeight = "500";
        });

        // 見出し行（1行目）のthとtdに背景色と太字を追加
        // theadがある場合はtheadのthとtd、ない場合は最初のtrのthとtdを選択
        let headers;
        const thead = table.querySelector("thead");
        if (thead) {
          // thead内のthとtdの両方を選択
          headers = thead.querySelectorAll("th, td");
        } else {
          // theadがない場合、最初の行のすべてのセルを選択
          // tbodyがある場合とない場合の両方に対応
          const firstRow = table.querySelector("tbody tr:first-child, tr:first-child");
          if (firstRow) {
            headers = firstRow.querySelectorAll("th, td");
          } else {
            headers = table.querySelectorAll("tr:first-child th, tr:first-child td");
          }
        }

        // 最初の行のセルをSetに保存（後で除外するため）
        const headerSet = new Set(headers);

        headers.forEach((header) => {
          // 空のセルでも確実に背景色を適用
          header.style.setProperty("background-color", bgColor, "important");
          // 見出し行のすべてのセルにfont-weightを適用
          header.style.fontWeight = "500";
          // 念のため、空のセルでも表示されるようにする
          if (!header.textContent.trim()) {
            header.style.minHeight = "1px";
          }
        });

        // データセル（td）は白背景のまま（ただし最初の行のtdは除外）
        const dataCells = table.querySelectorAll("td");
        dataCells.forEach((cell) => {
          // 最初の行のセルは除外
          if (!headerSet.has(cell)) {
            cell.style.backgroundColor = "#fff";
          }
        });
      });
    });
  }

  // Simplebarを初期化する関数
  function initSimplebar() {
    const sizeChartContainers = document.querySelectorAll(".c-acordion__table--size[data-simplebar]");

    sizeChartContainers.forEach((container) => {
      // 既にSimplebarが初期化されているかチェック
      if (!container.hasAttribute("data-simplebar-initialized")) {
        // Simplebarが利用可能な場合のみ初期化
        if (typeof SimpleBar !== "undefined") {
          try {
            new SimpleBar(container, {
              autoHide: false,
            });
          } catch (e) {
            // Simplebarの初期化に失敗した場合は無視
            console.warn("Simplebar initialization failed:", e);
          }
        }
        container.setAttribute("data-simplebar-initialized", "true");
      }
    });
  }

  // 初回実行
  applySizeChartStyles();

  // Simplebarを初期化（Simplebarが読み込まれた後に実行）
  function initAfterSimplebar() {
    if (typeof SimpleBar !== "undefined") {
      initSimplebar();
    } else {
      // Simplebarがまだ読み込まれていない場合、少し待ってから再試行
      setTimeout(initAfterSimplebar, 100);
    }
  }

  initAfterSimplebar();

  // DOMContentLoadedイベントでも実行
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      applySizeChartStyles();
      initAfterSimplebar();
    });
  } else {
    applySizeChartStyles();
    initAfterSimplebar();
  }

  // MutationObserverで動的に追加されたテーブルにも対応
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        applySizeChartStyles();
        // Simplebarの初期化も再実行
        setTimeout(initAfterSimplebar, 100);
      }
    });
  });

  // アコーディオンコンテンツを監視
  const accordionContents = document.querySelectorAll(".c-acordion__content");
  accordionContents.forEach((content) => {
    observer.observe(content, {
      childList: true,
      subtree: true,
    });
  });

  // リサイズイベントでfont-sizeを再計算
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      applySizeChartStyles();
    }, 100);
  });
})();

// Product Sticky Bar: 表示条件を変更（常にフッター表示時も非表示にする）
document.addEventListener("DOMContentLoaded", function () {
  // 既存のProductStickyBarインスタンスを取得
  const stickyBars = document.querySelectorAll("product-sticky-bar");

  stickyBars.forEach(function (stickyBar) {
    // IntersectionObserverを再設定
    const formElement = document.forms[stickyBar.getAttribute("form")];
    const footerElement = document.querySelector(".shopify-section--footer");

    if (!formElement || !footerElement) return;

    // 新しいIntersectionObserverを作成
    const observer = new IntersectionObserver(
      function (entries) {
        let formPassed = false;
        let footerVisible = false;

        entries.forEach(function (entry) {
          if (entry.target === formElement) {
            formPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          }
          if (entry.target === footerElement) {
            footerVisible = !entry.isIntersecting;
          }
        });

        // 表示条件を変更: フォームが通過した かつ フッターが表示されていない
        const shouldShow = formPassed && !footerVisible;
        stickyBar.classList.toggle("is-visible", shouldShow);

        // hidden属性も制御
        if (shouldShow) {
          stickyBar.removeAttribute("hidden");
        } else {
          stickyBar.setAttribute("hidden", "");
        }
      },
      {
        threshold: 0,
        rootMargin: "0px",
      },
    );

    // 要素を監視
    observer.observe(formElement);
    if (footerElement) {
      observer.observe(footerElement);
    }

    // 既存のオブザーバーを無効化するために、要素を一時的に非表示にして再表示
    // （既存のオブザーバーとの競合を避けるため）
    const originalObserver = stickyBar._customObserver;
    if (originalObserver) {
      originalObserver.disconnect();
    }
    stickyBar._customObserver = observer;
  });

  // 動的に追加された要素に対応
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.tagName === "PRODUCT-STICKY-BAR") {
          // 新しいsticky barが追加された場合、初期化処理を再実行
          setTimeout(function () {
            const formElement = document.forms[node.getAttribute("form")];
            const footerElement = document.querySelector(".shopify-section--footer");

            if (!formElement || !footerElement) return;

            const newObserver = new IntersectionObserver(
              function (entries) {
                let formPassed = false;
                let footerVisible = false;

                entries.forEach(function (entry) {
                  if (entry.target === formElement) {
                    formPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
                  }
                  if (entry.target === footerElement) {
                    footerVisible = !entry.isIntersecting;
                  }
                });

                const shouldShow = formPassed && !footerVisible;
                node.classList.toggle("is-visible", shouldShow);

                if (shouldShow) {
                  node.removeAttribute("hidden");
                } else {
                  node.setAttribute("hidden", "");
                }
              },
              {
                threshold: 0,
                rootMargin: "0px",
              },
            );

            newObserver.observe(formElement);
            if (footerElement) {
              newObserver.observe(footerElement);
            }
            node._customObserver = newObserver;
          }, 100);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// Password Confirm Form: ボタンの背景色をインラインスタイルで設定
document.addEventListener("DOMContentLoaded", function () {
  function applyPasswordConfirmButtonStyle() {
    const passwordConfirmForm = document.querySelector("#password-confirm-form");
    if (!passwordConfirmForm) return;

    const button = passwordConfirmForm.querySelector("input.btn");
    if (button) {
      button.style.backgroundColor = "#2E2C28";
    }
  }

  // 初期化
  applyPasswordConfirmButtonStyle();

  // 動的に追加された要素に対応
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length > 0) {
        applyPasswordConfirmButtonStyle();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// 検索サイドバー: Drawerベースのカスタム要素
// NOTE: テーマ側で [aria-controls="header-search-..."] のクリックをトグルしているため、
// custom.jsで show() を直接呼ぶと「開いて即閉じる」競合が起きる。ここでは要素の拡張（フォーカス等）だけ行う。
customElements.whenDefined("x-drawer").then(() => {
  const BaseDrawer = customElements.get("x-drawer");
  if (!BaseDrawer || window.customElements.get("header-search-drawer")) return;

  class HeaderSearchDrawer extends BaseDrawer {
    connectedCallback() {
      super.connectedCallback();

      if (this.dataset.initialized === "true") return;
      this.dataset.initialized = "true";

      // 検索フォームの送信を処理（Enterで /search?q=... へ）
      const form = this.querySelector("#predictive-search-form");
      if (form) {
        form.addEventListener("submit", (e) => {
          e.preventDefault();
          const input = form.querySelector('input[name="q"]');
          if (input && input.value.trim()) {
            window.location.href = `${form.action}?q=${encodeURIComponent(input.value.trim())}`;
          }
        });
      }

      // 開いた時に検索入力欄にフォーカス
      this.addEventListener("dialog:after-show", () => {
        const input = this.querySelector('input[name="q"]');
        if (input) setTimeout(() => input.focus(), 100);
      });
    }
  }

  window.customElements.define("header-search-drawer", HeaderSearchDrawer);
});

// Favorite Text: ._SFA__list > #favorit-list内にliタグがあれば非表示にする
// また、._SFA__list > #favorit-list内のli::beforeをdisplay:none;にする
document.addEventListener("DOMContentLoaded", function () {
  let sfaListObserver = null;
  let styleElement = null;

  // li::beforeをdisplay:none;にするスタイルを追加
  function addLiBeforeStyle() {
    if (styleElement) return;

    styleElement = document.createElement("style");
    styleElement.id = "custom-favorit-list-li-before-style";
    styleElement.textContent = "._SFA__list > #favorit-list li::before { display: none !important; }";
    document.head.appendChild(styleElement);
  }

  function checkFavoriteTextVisibility() {
    const favoriteText = document.getElementById("favoriteText");
    if (!favoriteText) return;

    // ._SFA__list要素を探す（毎回再検索して後から追加された要素にも対応）
    const sfaList = document.querySelector("._SFA__list");
    if (!sfaList) {
      // ._SFA__listが存在しない場合は表示状態を維持
      return;
    }

    // ._SFA__list要素が見つかった場合、その要素を直接監視する
    if (!sfaListObserver) {
      sfaListObserver = new MutationObserver(function () {
        setTimeout(checkFavoriteTextVisibility, 50);
      });

      sfaListObserver.observe(sfaList, {
        childList: true,
        subtree: true,
        attributes: false,
      });
    }

    // ._SFA__list内のid="favorit-list"要素を探す
    const favoritList = sfaList.querySelector("#favorit-list");
    if (!favoritList) {
      // #favorit-listが存在しない場合は表示状態を維持
      return;
    }

    // #favorit-list内にliタグが存在するかチェック
    const hasLiElements = favoritList.querySelectorAll("li").length > 0;

    // liタグがあれば非表示にする
    if (hasLiElements) {
      favoriteText.style.display = "none";
    } else {
      favoriteText.style.display = "";
    }
  }

  // 初期チェック
  checkFavoriteTextVisibility();

  // li::beforeスタイルを追加
  addLiBeforeStyle();

  // MutationObserverでDOMの変更を監視（favoriteTextや_SFA__listが後から追加される場合に対応）
  const mainObserver = new MutationObserver(function (mutations) {
    let shouldCheck = false;

    mutations.forEach(function (mutation) {
      // ノードが追加・削除された場合
      if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
        // 追加されたノードが_SFA__listまたはその子要素、またはfavoriteTextかチェック
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            // 要素ノードの場合
            if (node.id === "favoriteText" || node.classList.contains("_SFA__list") || node.querySelector("._SFA__list") || node.querySelector("#favoriteText") || node.querySelector("#favorit-list")) {
              shouldCheck = true;
            }
          }
        });

        // 削除されたノードが_SFA__listまたはその子要素かチェック
        mutation.removedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            if (node.classList.contains("_SFA__list") || node.querySelector("._SFA__list") || node.id === "favorit-list") {
              shouldCheck = true;
              // _SFA__listが削除された場合、そのオブザーバーも無効化
              if (sfaListObserver) {
                sfaListObserver.disconnect();
                sfaListObserver = null;
              }
            }
          }
        });

        // 一般的なノード追加・削除でもチェック（liタグが追加される可能性）
        if (!shouldCheck) {
          shouldCheck = true;
        }
      }
      // class属性が変更された場合（_SFA__listクラスが追加/削除される可能性）
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        const target = mutation.target;
        // _SFA__listクラスが追加/削除された場合
        if (target.classList.contains("_SFA__list") || target.closest("._SFA__list")) {
          shouldCheck = true;
          // _SFA__list要素が見つかった場合、監視を再設定
          if (target.classList.contains("_SFA__list") && !sfaListObserver) {
            setTimeout(checkFavoriteTextVisibility, 50);
          }
        }
      }
      // id属性が変更された場合（favorit-listが追加される可能性）
      if (mutation.type === "attributes" && mutation.attributeName === "id") {
        const target = mutation.target;
        if (target.id === "favorit-list" || target.closest("._SFA__list")) {
          shouldCheck = true;
        }
      }
    });

    if (shouldCheck) {
      // 少し遅延させてからチェック（DOM更新が完了してから）
      setTimeout(checkFavoriteTextVisibility, 50);
    }
  });

  // document.body全体を監視（後からJSで要素が増える可能性を考慮）
  mainObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "id"],
  });
});

// Product Card: 初期状態でカラースウォッチを未選択にする
(function () {
  // 既に初期化済みのproduct-cardを追跡
  const initializedCards = new WeakSet();
  const SECTION_OBSERVER_MARK = "cProductCardSwatchClearObserverAttached";

  function clearProductCardSwatches(card) {
    // 既に初期化済みの場合はスキップ（ユーザーが操作した後は影響を受けないようにする）
    if (initializedCards.has(card)) {
      return;
    }

    const swatchInputs = card.querySelectorAll('.product-card__info input[type="radio"]');
    if (swatchInputs.length === 0) {
      return;
    }

    // 初期状態でcheckedになっているラジオボタンを解除
    swatchInputs.forEach((input) => {
      if (input.checked) {
        input.checked = false;
      }
    });

    // 初期化済みとしてマーク
    initializedCards.add(card);

    // ユーザーがスウォッチをクリックしたら、そのcardは以後変更しないようにする
    // これにより、テーマのJavaScriptがDOMを変更しても影響を受けない
    swatchInputs.forEach((input) => {
      input.addEventListener(
        "change",
        function () {
          // 変更イベントが発生したら、このcardは初期化済みとして扱う
          initializedCards.add(card);
        },
        { once: true },
      );
    });
  }

  function clearAllProductCardSwatches() {
    const productCards = document.querySelectorAll("product-card.product-card, product-card");
    productCards.forEach((card) => {
      clearProductCardSwatches(card);
    });
  }

  function attachMainCollectionSectionObserver() {
    const section = document.querySelector(".shopify-section--main-collection");
    if (!section) return;

    // Prevent duplicate observers on the same section element
    if (section.dataset[SECTION_OBSERVER_MARK] === "true") return;
    section.dataset[SECTION_OBSERVER_MARK] = "true";

    const observer = new MutationObserver(function (mutations) {
      // Facet-link pagination/sort/filter updates replace section children via theme.js `replaceChildren`
      let shouldClear = false;
      for (const m of mutations) {
        if (m.type === "childList" && ((m.addedNodes && m.addedNodes.length) || (m.removedNodes && m.removedNodes.length))) {
          shouldClear = true;
          break;
        }
      }
      if (!shouldClear) return;

      // Defer to ensure new DOM is in place
      setTimeout(clearAllProductCardSwatches, 0);
    });

    // IMPORTANT: observe only direct child changes on the section to avoid reacting to swatch-driven media replacements inside cards
    observer.observe(section, { childList: true, subtree: false });
  }

  // 初期化時に実行
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      clearAllProductCardSwatches();
      attachMainCollectionSectionObserver();
    });
  } else {
    clearAllProductCardSwatches();
    attachMainCollectionSectionObserver();
  }

  // AJAXでセクションが読み込まれた後も実行
  document.addEventListener("shopify:section:load", function () {
    setTimeout(function () {
      clearAllProductCardSwatches();
      attachMainCollectionSectionObserver();
    }, 100);
  });

  // フィルターやソートで商品リストが更新された場合にも対応
  // ShopifyテーマのAJAX更新を検知
  document.addEventListener("shopify:collection:updated", function () {
    setTimeout(function () {
      clearAllProductCardSwatches();
      attachMainCollectionSectionObserver();
    }, 100);
  });
})();

// Product Card: スウォッチ画像のプリロード（スマホでの切替遅延対策）
// - デスクトップではホバー時にテーマ側がプリロードするが、スマホではホバーがないため
//   タップ時に初めて画像をロードし、complete を待つため遅延が発生する
// - pointerdown でタッチ/クリック開始を検知し、change 発火前に画像をプリロードする
(function () {
  const CACHE = new Map();

  function getMediaUrl(media) {
    if (!media?.preview_image?.src) return null;
    const src = media.preview_image.src;
    return src.startsWith("//") ? `https:${src}` : src;
  }

  function preloadMedia(media) {
    const url = getMediaUrl(media);
    if (!url || CACHE.has(url)) return;
    CACHE.set(url, true);
    const img = new Image();
    img.src = url;
  }

  function preloadSwatchMedia(input) {
    if (!input || !input.hasAttribute("data-variant-media")) return;
    if (input.checked) return;

    try {
      const media = JSON.parse(input.getAttribute("data-variant-media"));
      preloadMedia(media);

      const secondary = input.getAttribute("data-variant-secondary-media");
      if (secondary) {
        try {
          preloadMedia(JSON.parse(secondary));
        } catch (_) {}
      }
    } catch (_) {}
  }

  document.addEventListener(
    "pointerdown",
    function (e) {
      const card = e.target?.closest?.("product-card");
      if (!card) return;

      let input = null;
      if (e.target instanceof HTMLInputElement && e.target.type === "radio") {
        input = e.target;
      } else {
        const label = e.target?.closest?.("label[for]");
        if (label) input = label.control || card.querySelector("#" + CSS.escape(label.htmlFor));
      }

      if (input && input.closest(".product-card__info")) {
        preloadSwatchMedia(input);
      }
    },
    { passive: true, capture: true },
  );
})();

// Product Card: スウォッチ切替直後のhover白抜け対策
// - テーマ側は secondary があるカードで hover 時に primary を opacity:0 にする
// - スウォッチ切替（画像差し替え/フェード）と競合すると、一瞬 primary/secondary が両方見えず白くなることがあるため
//   切替中は hover の2枚目表示を一時的に無効化する
(function () {
  const SWITCHING_CLASS = "c-product-card__media_switching";
  const BROKEN_SECONDARY_CLASS = "c-product-card__media_secondary-broken";
  const SWITCHING_TTL_MS = 900;

  function getCardFromEventTarget(target) {
    if (!target || !(target instanceof Element)) return null;
    return target.closest("product-card");
  }

  function getPrimaryImg(card) {
    return card?.querySelector?.(".product-card__image--primary") || null;
  }

  function getSecondaryImg(card) {
    return card?.querySelector?.(".product-card__image--secondary") || null;
  }

  function hasUsableImageSrc(img) {
    if (!img) return false;
    // `currentSrc` is best, fallback to `src` attribute
    const current = img.currentSrc || "";
    const src = img.getAttribute("src") || "";
    return (current && current !== "about:blank") || (src && src !== "about:blank");
  }

  function markSwitching(card) {
    if (!card) return;
    card.classList.add(SWITCHING_CLASS);

    // Failsafe: remove class after TTL so we never permanently block hover
    window.setTimeout(() => {
      card.classList.remove(SWITCHING_CLASS);
    }, SWITCHING_TTL_MS);

    // Also try to remove earlier when images are ready (best-effort)
    const primary = getPrimaryImg(card);
    const secondary = getSecondaryImg(card);

    const maybeDone = () => {
      const p = getPrimaryImg(card);
      const s = getSecondaryImg(card);
      const primaryReady = !p || p.complete;
      const secondaryReady = !s || s.complete;

      if (primaryReady && secondaryReady) {
        card.classList.remove(SWITCHING_CLASS);
      }
    };

    if (primary && !primary.complete) primary.addEventListener("load", maybeDone, { once: true });
    if (secondary && !secondary.complete) secondary.addEventListener("load", maybeDone, { once: true });
    window.setTimeout(maybeDone, 50);
  }

  // スウォッチ切替（click/change）開始を検知して switching 状態にする
  document.addEventListener(
    "change",
    function (e) {
      const target = e.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.type !== "radio") return;
      // product-card の swatch は variant media を持つものだけ対象
      if (!target.hasAttribute("data-variant-media")) return;
      if (!target.closest(".product-card__info")) return;

      const card = getCardFromEventTarget(target);
      if (!card) return;
      markSwitching(card);
    },
    true,
  );

  // hover 時に secondary が壊れている/読み込めていない場合は primary を優先して白抜けを防ぐ
  document.addEventListener(
    "pointerover",
    function (e) {
      const target = e.target;
      const card = getCardFromEventTarget(target);
      if (!card) return;

      const secondary = getSecondaryImg(card);
      if (!secondary) {
        card.classList.remove(BROKEN_SECONDARY_CLASS);
        return;
      }

      // secondary があるのに表示できるsrcが無い場合は primary を強制
      if (!hasUsableImageSrc(secondary)) {
        card.classList.add(BROKEN_SECONDARY_CLASS);
      } else {
        card.classList.remove(BROKEN_SECONDARY_CLASS);
      }
    },
    true,
  );
})();

/*-------------------------
  Fade In Animation（セクション用）
  ページネーション等のAJAX置換後も fade-up 要素を再観察する
  スマホ: レイアウト確定後・初期フレーム描画後にアニメーションを確実に発火
-------------------------*/
(function () {
  const SECTION_FADE_SELECTOR = ".fade-in, .fade-up";
  const COLLECTION_CARD_FADE_SELECTOR = ".shopify-section--main-collection .product-list > product-card.product-card";

  const fadeObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          fadeObserver.unobserve(el);
          el.classList.add("is-visible");
        }
      });
    },
    {
      threshold: 0,
      rootMargin: "0px 0px -30% 0px",
    },
  );

  function observeFadeElements(root) {
    if (!root) return;
    const selector = `${SECTION_FADE_SELECTOR}, ${COLLECTION_CARD_FADE_SELECTOR}`;
    const elements = [];

    if (root.matches?.(selector)) {
      elements.push(root);
    }

    elements.push(...root.querySelectorAll(selector));
    elements.forEach((el) => {
      if (!el.classList.contains("is-visible")) {
        fadeObserver.observe(el);
      }
    });
  }

  function initFadeAnimation() {
    // 1フレーム待ってレイアウト確定後に観察開始（スマホでのタイミング改善）
    requestAnimationFrame(() => {
      observeFadeElements(document.body);
    });
  }

  // 初期表示時（DOMContentLoaded 後、レイアウト確定を待つ）
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFadeAnimation);
  } else {
    initFadeAnimation();
  }

  // テーマエディタでブロック追加・設定変更によりセクションが再描画された場合も、
  // 新しい fade 要素を監視し直して非表示のまま残ることを防ぐ
  document.addEventListener("shopify:section:load", function (e) {
    requestAnimationFrame(() => {
      observeFadeElements(e.target);
    });
  });

  // facet-linkによるページネーション/フィルター/ソートでAJAX置換された後、
  // 新しい .fade-up 要素を観察（置換前は opacity:0 のまま表示されない問題を解消）
  document.addEventListener("facet:update", function (e) {
    const url = e.detail?.url;
    if (!url) return;
    const sectionId = new URL(url).searchParams.get("section_id");
    const section = sectionId ? document.getElementById("shopify-section-" + sectionId) : null;
    if (!section) return;

    const mo = new MutationObserver(function (mutations) {
      for (const m of mutations) {
        if (m.type === "childList" && (m.addedNodes?.length || m.removedNodes?.length)) {
          mo.disconnect();
          requestAnimationFrame(() => {
            observeFadeElements(section);
          });
          return;
        }
      }
    });
    mo.observe(section, { childList: true, subtree: false });
  });

  // CLEARボタン等で shopify:collection:updated が発火した場合（replaceWithでセクション全体が置換済み）
  document.addEventListener("shopify:collection:updated", function () {
    const section = document.querySelector(".shopify-section--main-collection");
    if (section) {
      requestAnimationFrame(() => {
        observeFadeElements(section);
      });
    }
  });
})();

/* アプリ埋め込み商品タイトル: product-title-display.liquid と同じ〔品番〕除去を ._gai-prod-tit に適用（遅延描画対応） */
(function initGaiProdTitSkuStrip() {
  var SELECTOR = "._gai-prod-tit";
  var SENTINEL = "[[[__PTD_SPLIT_END__]]]";

  /** @param {string} title */
  function stripProductTitleDisplaySku(title) {
    if (typeof title !== "string" || !title) return title;
    var titleParts = (title + SENTINEL).split("〕");
    if (titleParts.length <= 1) return title;

    var partBeforeBracket = titleParts[0].split("〔")[0].trim();
    var partAfterBracket = "";
    for (var i = 1; i < titleParts.length; i++) {
      var p = titleParts[i];
      if (i === 1) {
        partAfterBracket = p.trim();
      } else {
        partAfterBracket = partAfterBracket + "〕" + p;
      }
    }
    partAfterBracket = partAfterBracket.split(SENTINEL).join("").trim();

    if (partBeforeBracket && partAfterBracket) return partBeforeBracket + " " + partAfterBracket;
    if (partBeforeBracket) return partBeforeBracket;
    if (partAfterBracket) return partAfterBracket;
    return title;
  }

  function applyToElement(el) {
    try {
      if (!el || el.nodeType !== 1) return;
      var raw = el.textContent;
      if (raw == null) return;
      var next = stripProductTitleDisplaySku(String(raw));
      if (next !== raw) el.textContent = next;
    } catch (_) {}
  }

  function applyAll(root) {
    try {
      if (!root || !root.querySelectorAll) return;
      var i;
      var nodes = root.querySelectorAll(SELECTOR);
      for (i = 0; i < nodes.length; i++) applyToElement(nodes[i]);
      if (root.nodeType === 1 && typeof root.matches === "function" && root.matches(SELECTOR)) {
        applyToElement(root);
      }
    } catch (_) {}
  }

  var scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      applyAll(document.body);
    });
  }

  var observerAttached = false;
  function startObserver() {
    if (observerAttached) return;
    try {
      if (!document.body) return;
      observerAttached = true;
      var mo = new MutationObserver(function () {
        scheduleApply();
      });
      mo.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    } catch (_) {
      observerAttached = false;
    }
  }

  function run() {
    if (!document.body) {
      document.addEventListener("DOMContentLoaded", run);
      return;
    }
    applyAll(document.body);
    startObserver();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
